<template>
  <div class="header-vote-button">
    <a-link
      :to="ceoVoteFormTo"
      class="header-vote-button__segment header-vote-button__segment--ceo uppercase"
      :class="{ 'header-vote-button__segment--active': isCeoHighlighted }"
      @click="handleClick"
    >
      Vote CEO
    </a-link>

    <a-link
      :to="brandVoteFormTo"
      class="header-vote-button__segment header-vote-button__segment--brand uppercase"
      :class="{ 'header-vote-button__segment--active': isBrandHighlighted }"
      @click="handleClick"
    >
      Vote Brand
    </a-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MODAL } from 'modals/AModalWrapper/enums'
import { ROUTE, ROUTE_NAME } from 'enums/routes'
import { ELEMENT_ID, ELEMENT_SELECTOR_BY_ELEMENT_ID } from 'enums/element-id'

const VOTE_FORM_HASH = ELEMENT_SELECTOR_BY_ELEMENT_ID[ELEMENT_ID.VOTE_FORM]

export default {
  name: 'AHeaderVoteButton',
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn'
    }),
    ceoVoteFormTo() {
      return {
        path: ROUTE.CEO_VOTING,
        hash: VOTE_FORM_HASH
      }
    },
    brandVoteFormTo() {
      return {
        path: ROUTE.VOTING,
        hash: VOTE_FORM_HASH
      }
    },
    isCeoActive() {
      return (
        this.$route.name === ROUTE_NAME.CEO_VOTING ||
        this.$route.name === ROUTE_NAME.CEO_VOTING_THANK_YOU
      )
    },
    isBrandActive() {
      return (
        this.$route.name === ROUTE_NAME.VOTING ||
        this.$route.name === ROUTE_NAME.THANK_YOU
      )
    },
    isCeoHighlighted() {
      return this.isCeoActive || !this.isBrandActive
    },
    isBrandHighlighted() {
      return this.isBrandActive
    }
  },
  methods: {
    handleClick(event) {
      if (!this.isLoggedIn) {
        this.$helper.openModal(MODAL.AUTH)
      }

      this.$emit('click', event)
    }
  }
}
</script>

<style lang="scss" scoped>
$header-vote-button-bg: #101828;

.header-vote-button {
  display: flex;
  align-items: center;
  border-radius: 80px;
  background-color: $header-vote-button-bg;
  isolation: isolate;
  flex-shrink: 0;
}

.header-vote-button__segment {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 26px;
  border-radius: 80px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: $c--white;
  opacity: 0.9;
  text-decoration: none;
  white-space: nowrap;
  position: relative;
  z-index: 1;

  &--brand {
    margin-left: -8px;
  }

  &--active {
    background-color: $c--purple;
    z-index: 2;
  }
}
</style>
